<div class="giphy-box" *ngIf="giphyService.isShowGif">
  <div class="giphy-box-wrapper">
    <div class="giphy-search-box">
      <div class="search-close" (click)="giphyService.showHideGiphy()"></div>
      <div class="search-input">
        <form>
          <input
            [(ngModel)]="giphySearchValue"
            class="input-search-giphy"
            type="text"
            placeholder="Search GIPHY"
            name="search"
            #inputSearch
          />
          <button class="btn-search-giphy" type="submit" (click)="searchGiphy()"></button>
          <div class="btn-close-search" *ngIf="isShowResetSearch" (click)="resetSearch()"></div>
        </form>
      </div>
    </div>
    <div class="giphy-data">
      <ul class="data-listing" *ngIf="gfData.length > 0">
        <li
          class="data-item"
          *ngFor="let image of gfData"
          (click)="setGift(image); this.giphyService.showHideGiphy()"
        >
          <img [src]="image.images.downsized_medium.url" [alt]="image.slug" />
        </li>
      </ul>
      <div class="no-result" *ngIf="gfData.length === 0">
        No result found!
      </div>
    </div>
  </div>
</div>
<div class="giphy-image" *ngIf="giphyService.imageGiphy !== ''">
  <img
    *ngIf="giphyService.imageGiphy !== ''"
    [src]="giphyService.imageGiphy.images.original.url"
    [alt]="giphyService.imageGiphy.slug"
  />
  <div class="remove-image" (click)="setGift('')">
    <span></span>
  </div>
</div>
